import React from "react";
import { useTranslation } from "react-i18next";
import Modal from "../common/Modal";
//import UserBcCouponDetail from "./UserBcCouponDetail";
import CouponItemDetail from "../coupon/CouponItemDetail"; // ปรับ path ตามจริง

const UseUserBcCouponModal = ({
  show,
  value,
  onClose,
  onConfirm,
  seniorLayout,
}) => {
  const { t } = useTranslation();
  const timeout = value?.usageTimeout ?? 15;
  //console.log("Modal visible?", show, "Coupon:", value);

  return (
    <Modal
      show={show}
      closable
      buttons
      acceptButton={t("confirm")}
      onCancel={onClose}
      onAccept={onConfirm}
      containerClass="sm:pt-5 pt-8"
    >
      <div className="w-full h-full flex flex-col">
        <div className="w-full h-full overflow-y-auto">
          <CouponItemDetail userCoupon={true} value={value} />
        </div>
        <div
          className={`w-full pt-2 font-normal text-center text-danger break-words ${
            seniorLayout ? "text-base" : "text-sm"
          }`}
          dangerouslySetInnerHTML={{
            __html: t("tp_coupon_validation_warning", { timeout }),
          }}
        />
      </div>
    </Modal>
  );
};

export default UseUserBcCouponModal;
